import React, {Component} from 'react';
import {Form, Upload, Icon, message, Modal} from "antd";
import UploadWall from "../../../../components/upload/UploadWall";
import {FILE_TYPE, VIDEO_TYPE} from "../../../../constants";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import BaseComponent from "../../../../base/BaseComponent";

import {DetailDialog as Audio} from "../../../resource/view/dialog/audio/audio";
import {DetailDialog as Picture} from "../../../resource/view/dialog/picture/picture";
import {Video} from "../../../resource/view/dialog/CurrencyResourceDialog";

class uploadDetails extends BaseComponent {

    constructor(props) {
        super(props);
        this.state={
            fileList:props.data || [],
            maxSize: 1024*10
        }
    }


    beforeUpload = async file => {
        let res = FILE_TYPE.find(item=>file.name.endsWith(item));
        let sizeValue =  file.size / 1024 / 1024;
        return new Promise((resolve, reject) => {
            if(res){
                if(sizeValue < this.state.maxSize){
                    resolve()
                }else {
                    message.error(`文件大小不能超过${this.state.videoMaxSize}MB！`);
                    reject();
                }
            }else{
                message.error(`${file.name}文件格式不正确，只能上传以下格式${FILE_TYPE.join("，")}`);
                reject();
            }
        });
    };

    audioPath;
    picPath;
    videoPath;
    render() {
        let {fileList} = this.state;
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex",flexShrink: 0}}>
                {fileList && fileList.length > 0 &&
                    <div>
                        <UploadWall
                            accept={"." + FILE_TYPE.join(",.")}
                            multiple={true}
                            action="/storage/uploadFile"
                            fileList={fileList}
                            style={{padding: "10px 0 0 0",width:"642px"}}
                            customRequest={new ChunkUpload({
                                checkFileURL:"/storage/checkFile",
                                checkChunkURL:"/storage/checkChunk",
                                uploadChunkURL:"/storage/uploadChunk",
                                chunkUploadOverURL:"/storage/chunkIsUploadOver",
                                mergeChunksURL:"/storage/mergeChunk",
                                fileError:(md5, mergeResult, newFile)=>{
                                    Modal.error({
                                        title: '上传错误！',
                                        content: <div>文件  <span style={{color: 'red'}}>{mergeResult.name}</span>上传错误！</div>,
                                        onOk: () => {
                                            let newFiles = fileList.filter(item=>item.md5 !== md5);
                                            this.setState({fileList: newFiles})
                                        }
                                    });
                                }
                            }).start}
                            icons={["play", "eye", "listen", "download"]}
                            onEditFileNameCall={(file, fileName)=>{
                                this.state.fileList.forEach(item=>{
                                    if(item.id === file.id) {
                                        item.name = fileName
                                    }
                                });
                                this.setState({},()=>{
                                });
                            }}
                            showUploadBtn={false}
                            uploadBtnName={"上传附件"}
                            beforeUpload={this.beforeUpload}
                            onChange={this.handleChangeFileList}
                            onRemove={this.handleRemoveFileList}
                            onDownload={this.onDownload}
                            onListen={file => {
                                this.audioPath = file.path;
                                this.setState({}, ()=>{
                                    this.detailDialogAudio.show();
                                });
                            }}
                            onPreview={file => {
                                this.picPath = file.path;
                                this.setState({}, ()=>{
                                    this.detailDialogPic.show();
                                });
                            }}
                            onPlay={file => {
                                this.videoPath = file.path;
                                this.setState({}, ()=>{
                                    this.detailDialogVideo.show();
                                });
                            }}
                        />
                        <Audio ref={ref=>this.detailDialogAudio=ref} path={this.audioPath}/>
                        <Picture ref={ref=>this.detailDialogPic=ref} path={this.picPath}/>
                        <Video ref={ref=>this.detailDialogVideo=ref} path={this.videoPath}/>
                    </div>}
            </Form.Item>
        )
    }

    handleChangeFileList = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                if(item.type &&  item.type.indexOf("video")>-1) {
                    item.url = info.file.response && info.file.response.thumbnailsPlayPath;
                } else {
                    item.url = info.file.response && info.file.response.path;
                }
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.isChunk = true;
                item.status = info.file.status;
                item.md5 = info.file.originFileObj && info.file.originFileObj.md5;
                item.id = info.file.response && info.file.originFileObj._id;
            }
            return item;
        });
        this.setState({fileList: info.fileList},()=>{
            console.log("fileList=================",info.fileList)
        });
    };

    handleRemoveFileList = file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.setState({
            fileList
        });
    };

    onDownload = (file) => {
        console.log(file.path);
        if(file.path) {
            this.request({
                url: file.path+"?download=1",
                method: "downloadGet",
                contentType: "json",
            });
        } else {
            console.log("文件path丢失")
        }
    };

}

export default uploadDetails;
